import { useTranslation } from '@linka/i18n';
import { Link, useMatches } from 'react-router';
import { type BreadcrumbItem, Breadcrumb as UiBreadcrumb } from '../../breadcrumb/breadcrumb';

interface BreadcrumbProps {
  hideHome?: boolean;
}

type RouteHandle = { crumb?: () => React.ReactNode };

export const Breadcrumb = ({ hideHome }: BreadcrumbProps) => {
  const t = useTranslation();
  const matches = useMatches();

  const crumbs: BreadcrumbItem[] = matches
    .filter((match) => Boolean((match.handle as RouteHandle)?.crumb))
    .map((match) => ({
      id: match.id,
      label: <Link to={`${match.pathname}${window.location.search}`}>{(match.handle as RouteHandle).crumb?.()}</Link>,
      href: `${match.pathname}${window.location.search}`,
      isCurrent: window.location.pathname === match.pathname,
    }));

  return (
    <UiBreadcrumb
      crumbs={crumbs}
      homeHref={hideHome ? undefined : '/events'}
      homeAriaLabel={t('my-events')}
      ariaLabel={t('navigation-menu')}
    />
  );
};
